export const getImageDimensions = (file: File): Promise<{ height: number; width: number }> => {
    return new Promise(resolve => {
        const img = new Image();

        img.onload = () => {
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight,
            });
            window.URL.revokeObjectURL(img.src); // release object immediately after read
        };
        img.src = window.URL.createObjectURL(file); // setting src triggers onload
    });
};
